import React from "react";

const ImeiRecordDetailSkeleton = () => {
  return (
    <>
      <div className="imei-detail-skeleton">
        {/* Back button skeleton */}
        <div className="skeleton-back-btn">
          <div className="skeleton-icon"></div>
          <div className="skeleton-text skeleton-back-text"></div>
        </div>

        <div className="card">
          {/* Record Summary Skeleton */}
          <div className="detail-summary-skeleton">
            <div className="summary-grid-skeleton">
              <div className="summary-item-skeleton">
                <div className="skeleton-text skeleton-label"></div>
                <div className="skeleton-text skeleton-value"></div>
              </div>
              <div className="summary-item-skeleton">
                <div className="skeleton-text skeleton-label"></div>
                <div className="skeleton-text skeleton-value"></div>
              </div>
              <div className="summary-item-skeleton">
                <div className="skeleton-text skeleton-label"></div>
                <div className="skeleton-text skeleton-value"></div>
              </div>
              <div className="summary-item-skeleton">
                <div className="skeleton-text skeleton-label"></div>
                <div className="skeleton-text skeleton-value"></div>
              </div>
            </div>
            <div className="summary-notes-skeleton">
              <div className="skeleton-text skeleton-label"></div>
              <div className="skeleton-text skeleton-notes"></div>
            </div>
          </div>

          {/* Toolbar Skeleton */}
          <div className="entry-toolbar-skeleton">
            <div className="entry-search-skeleton">
              <div className="skeleton-input"></div>
            </div>
            <div className="skeleton-btn skeleton-add-btn"></div>
            <div className="toolbar-actions-skeleton">
              <div className="skeleton-btn skeleton-import-btn">
                <div className="skeleton-icon-small"></div>
                <div className="skeleton-text skeleton-btn-text"></div>
              </div>
              <div className="skeleton-btn skeleton-export-btn">
                <div className="skeleton-icon-small"></div>
                <div className="skeleton-text skeleton-btn-text"></div>
              </div>
            </div>
          </div>

          {/* Table Skeleton */}
          <div className="imei-table-wrapper-skeleton">
            <table className="imei-table-dual-skeleton">
              <colgroup>
                <col className="col-record" />
                <col className="col-imei" />
                <col className="col-action" />
                <col className="col-record" />
                <col className="col-imei" />
                <col className="col-action" />
              </colgroup>
              <thead>
                <tr>
                  <th>Record ID</th>
                  <th>IMEI Number</th>
                  <th>Action</th>
                  <th>Record ID</th>
                  <th>IMEI Number</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: 10 }).map((_, index) => (
                  <tr key={index} className="imei-skeleton-row">
                    <td>
                      <div className="skeleton-text skeleton-record-id"></div>
                    </td>
                    <td>
                      <div className="skeleton-text skeleton-imei"></div>
                    </td>
                    <td className="actions">
                      <div className="skeleton-btn skeleton-delete-btn"></div>
                    </td>
                    <td>
                      <div className="skeleton-text skeleton-record-id"></div>
                    </td>
                    <td>
                      <div className="skeleton-text skeleton-imei"></div>
                    </td>
                    <td className="actions">
                      <div className="skeleton-btn skeleton-delete-btn"></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style jsx>{`
        .imei-detail-skeleton {
          padding: 20px;
        }

        .skeleton-back-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 20px;
          padding: 8px 0;
        }

        .skeleton-icon {
          width: 16px;
          height: 16px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 2px;
        }

        .skeleton-icon-small {
          width: 16px;
          height: 16px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 2px;
        }

        .skeleton-text {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
          height: 1rem;
        }

        .skeleton-btn {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 6px;
        }

        .skeleton-back-text {
          width: 200px;
          height: 1.2rem;
        }

        .detail-summary-skeleton {
          padding: 20px;
          border-bottom: 1px solid #eaeef2;
        }

        .summary-grid-skeleton {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin-bottom: 20px;
        }

        .summary-item-skeleton {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .skeleton-label {
          width: 80px;
          height: 0.9rem;
        }

        .skeleton-value {
          width: 120px;
          height: 1.1rem;
        }

        .summary-notes-skeleton {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .skeleton-notes {
          width: 100%;
          height: 1.1rem;
        }

        .entry-toolbar-skeleton {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 20px;
          border-bottom: 1px solid #eaeef2;
          flex-wrap: wrap;
        }

        .entry-search-skeleton {
          flex: 1;
          min-width: 200px;
        }

        .skeleton-input {
          width: 100%;
          height: 40px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 6px;
        }

        .skeleton-add-btn {
          width: 60px;
          height: 40px;
        }

        .toolbar-actions-skeleton {
          display: flex;
          gap: 12px;
          margin-left: auto;
        }

        .skeleton-import-btn,
        .skeleton-export-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          height: 40px;
        }

        .skeleton-btn-text {
          width: 100px;
          height: 1rem;
        }

        .imei-table-wrapper-skeleton {
          max-height: 600px;
          overflow: hidden;
        }

        .imei-table-dual-skeleton {
          width: 100%;
          border-collapse: collapse;
        }

        .imei-table-dual-skeleton thead th {
          padding: 16px 20px;
          text-align: left;
          background-color: #f8f9fa;
          border-bottom: 1px solid #eaeef2;
          font-weight: 600;
          color: #495057;
        }

        .imei-skeleton-row {
          border-bottom: 1px solid #f1f5f9;
        }

        .imei-skeleton-row td {
          padding: 16px 20px;
          vertical-align: middle;
        }

        .skeleton-record-id {
          width: 80px;
          height: 1.1rem;
        }

        .skeleton-imei {
          width: 150px;
          height: 1.1rem;
        }

        .skeleton-delete-btn {
          width: 32px;
          height: 32px;
          border-radius: 6px;
        }

        .actions {
          text-align: center;
        }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .summary-grid-skeleton {
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 15px;
          }

          .entry-toolbar-skeleton {
            flex-direction: column;
            align-items: stretch;
          }

          .toolbar-actions-skeleton {
            margin-left: 0;
            justify-content: center;
          }

          .skeleton-record-id {
            width: 60px;
          }

          .skeleton-imei {
            width: 120px;
          }
        }

        @media (max-width: 576px) {
          .summary-grid-skeleton {
            grid-template-columns: 1fr;
            gap: 12px;
          }

          .skeleton-record-id {
            width: 50px;
          }

          .skeleton-imei {
            width: 100px;
          }
        }
      `}</style>
    </>
  );
};

export default ImeiRecordDetailSkeleton;
